import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useId, useState } from "react";
import { TabButton } from "./TabButton";
import { Section } from "./Tabs.styles";
import { RichTextStyle } from "../RichText";
import { TabNavigation } from "./TabNavigation";
var Tabs = function(param) {
    var _textStyle = param.textStyle, textStyle = _textStyle === void 0 ? RichTextStyle.Primary : _textStyle, tabs = param.tabs;
    var ref = useState(tabs[0].name), current = ref[0], setCurrent = ref[1];
    var tabGroup = "tabGroup-".concat(useId());
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TabNavigation, {
                children: tabs.map(function(param, tabIdx) {
                    var name = param.name;
                    return /*#__PURE__*/ _jsx(TabButton, {
                        behavior: {
                            onSelectTab: setCurrent
                        },
                        content: {
                            name: name,
                            position: tabIdx,
                            tabGroup: tabGroup
                        },
                        rules: {
                            activeTabName: current,
                            textStyle: textStyle
                        }
                    }, "".concat(tabGroup, "-tab-").concat(name));
                })
            }),
            tabs.map(function(param, tabIdx) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ _jsx(Section, {
                    id: "".concat(tabGroup, "-panel-").concat(tabIdx),
                    isHidden: current !== name,
                    "aria-labelledby": "".concat(tabGroup, "-tab-").concat(tabIdx),
                    role: "tabpanel",
                    tabIndex: 0,
                    textStyle: textStyle,
                    children: content
                }, "".concat(tabGroup, "-panel-").concat(name));
            })
        ]
    });
};
export { Tabs };
